import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const militaryStudentService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/military-student/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching military student list", error);
            throw error;
        }
    },

    async findById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/military-student/findById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById military student", error);
            throw error;
        }
    },

    async save(student: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/military-student/save`,
                student
            );
            return response.data;
        } catch (error) {
            console.error("Error save military student", error);
            throw error;
        }
    },

    async deleteById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/military-student/deleteById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById military student", error);
            throw error;
        }
    },
    async deleteByIds(ids: string[]): Promise<any> {
        try {
            const response = await apiClient.post<any>(`${BASE_URL}/api/v1/military-student/deleteByIds`, ids);
            return response.data;
        } catch (error) {
            console.error("Error deleteByIds military student", error);
            throw error;
        }
    },
    async deleteAllByYear(trancheYear: number, trancheNumber: number, universityId: number): Promise<any> {
        console.log('universityId', universityId)
        try {
            const queryParams = universityId > 0? `universityId=${universityId}` : '';
            const response =  await apiClient.delete<any>(`${BASE_URL}/api/v1/military-student/deleteAll/${trancheYear}/${trancheNumber}?${queryParams}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteByIds military student", error);
            throw error;
        }
    },
    async uploadStudentsCsv(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/military-student/upload-students-csv`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error save military student", error);
            throw error;
        }
    },
}

export default militaryStudentService;
